module.exports = __webpack_public_path__ + "static/media/gabi-logo.ed818de1.png";